const isOverflown = (element: HTMLElement) => {

	const {
		scrollHeight, clientHeight, scrollWidth, clientWidth
	} = element;

	return scrollHeight > clientHeight || scrollWidth > clientWidth;

};

export default isOverflown;
